import { WORK_MODULES } from "@/modules/workModuleCore";

export const BUYER_MODULE_VISIBILITY_EVENT = "visor:buyer-module-visibility-updated";

/** Módulos operativos que el diseñador puede ocultar al comprador. */
export const BUYER_VISIBILITY_MODULE_IDS = [
  WORK_MODULES.VISOR_SAT,
  WORK_MODULES.GESTION_DESPACHO,
  WORK_MODULES.TRAMITES_FISCALES,
  WORK_MODULES.MATERIALIDAD,
  WORK_MODULES.ASISTENTE_LABORAL,
  WORK_MODULES.ANALISIS_FINANCIERO,
];

export const BUYER_MODULE_VISIBILITY_LABELS = {
  [WORK_MODULES.VISOR_SAT]: "Visor Fiscal CFDI",
  [WORK_MODULES.GESTION_DESPACHO]: "Gestión Despacho",
  [WORK_MODULES.TRAMITES_FISCALES]: "Trámites Fiscales",
  [WORK_MODULES.MATERIALIDAD]: "Expedientes de operaciones",
  [WORK_MODULES.ASISTENTE_LABORAL]: "Asistente Laboral / REPSE",
  [WORK_MODULES.ANALISIS_FINANCIERO]: "Análisis financiero",
};

export const DEFAULT_BUYER_MODULE_VISIBILITY = Object.fromEntries(
  BUYER_VISIBILITY_MODULE_IDS.map((id) => [id, true]),
);

export function normalizeBuyerModuleVisibility(modules) {
  const next = { ...DEFAULT_BUYER_MODULE_VISIBILITY };
  if (modules && typeof modules === "object") {
    for (const id of BUYER_VISIBILITY_MODULE_IDS) {
      if (id in modules) next[id] = Boolean(modules[id]);
    }
  }
  return next;
}

/**
 * @param {string} moduleId — WORK_MODULES.*
 * @param {{ modules?: Record<string, boolean>, isPlatformDesigner?: boolean, buyerPreviewActive?: boolean }} ctx
 */
export function isBuyerModuleVisibleToUser(
  moduleId,
  { modules = DEFAULT_BUYER_MODULE_VISIBILITY, isPlatformDesigner = false, buyerPreviewActive = false } = {},
) {
  if (moduleId === WORK_MODULES.DISENADOR) return Boolean(isPlatformDesigner && !buyerPreviewActive);
  if (isPlatformDesigner && !buyerPreviewActive) return true;
  const normalized = normalizeBuyerModuleVisibility(modules);
  return normalized[moduleId] !== false;
}
